import { apolloClient } from "@/plugins/vue-apollo.js";

const toggleCurrency= (_variables) => {
  let responseFromApi;
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/currency/toggle_currency_status.graphql"),
      variables: _variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/currency/get_all_currencies.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          },
        };
        store.writeQuery({
          ...query,
          data: data,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { toggleCurrency };
